<template>
  <v-container fluid class="px-0">
    <v-row dense>
      <v-col>
        <CompanyInput :label="$t('ELE0134')" disabled :value="itemComputed.companyCd" />
      </v-col>
      <v-col>
        <PartCodeInput :label="$t('ELE0059')" disabled :value="itemComputed.partCd" />
      </v-col>
      <v-col>
        <TextFieldRef :label="$t('ELE0049')" :value="itemComputed.lotNo" />
      </v-col>
    </v-row>
    <v-row dense class="pt-4">
      <v-col cols="4">
        <TextFieldRef :label="$t('ELE0174')" right :value="itemComputed.qty" />
      </v-col>
      <v-col cols="8">
        <TextAreaRef :label="$t('ELE0054')" :value="itemComputed.remarks" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CompanyInput from '@/components/atoms/select/CompanyInput.vue'
import PartCodeInput from '@/components/atoms/select/PartCodeInput.vue'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput.vue'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef.vue'
import TextAreaRef from '@/components/atoms/base/text-field/TextAreaRef.vue'

export default {
  name: 'QRInformationForm',

  components: { CompanyInput, PartCodeInput, TextFieldInput, TextFieldRef, TextAreaRef },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    itemComputed: {
      get() {
        return this.item
      },
    },
  },
}
</script>
